/**
 * Placeholder — clearly labelled placeholder block where an authentic photograph of Chrissa is required.
 * Editorial: warm shadowed gradient, gold corner ticks, eyebrow label, generous aspect ratio.
 */
export default function PortraitPlaceholder({ label = "Portrait of Chrissa Valanti", aspect = "aspect-[4/5]", dark = true }) {
    return (
        <figure
            className={`relative overflow-hidden ${aspect} ${
                dark ? "bg-charcoal-soft" : "bg-ivory-soft"
            }`}
            aria-label={label}
        >
            {/* base texture */}
            <div
                className="absolute inset-0 opacity-90"
                style={{
                    background: dark
                        ? "radial-gradient(120% 80% at 30% 20%, rgba(197,160,89,0.18) 0%, rgba(26,26,26,1) 60%), linear-gradient(160deg, #1a1a1a 0%, #232020 100%)"
                        : "radial-gradient(120% 80% at 30% 20%, rgba(197,160,89,0.25) 0%, rgba(248,246,240,1) 65%), linear-gradient(160deg, #f8f6f0 0%, #ece8de 100%)",
                }}
            />
            {/* grain */}
            <div className="absolute inset-0 grain opacity-25 mix-blend-overlay" />

            {/* corner ticks */}
            <span className="absolute top-4 left-4 w-6 h-px bg-gold/70" />
            <span className="absolute top-4 left-4 h-6 w-px bg-gold/70" />
            <span className="absolute top-4 right-4 w-6 h-px bg-gold/70" />
            <span className="absolute top-4 right-4 h-6 w-px bg-gold/70" />
            <span className="absolute bottom-4 left-4 w-6 h-px bg-gold/70" />
            <span className="absolute bottom-4 left-4 h-6 w-px bg-gold/70" />
            <span className="absolute bottom-4 right-4 w-6 h-px bg-gold/70" />
            <span className="absolute bottom-4 right-4 h-6 w-px bg-gold/70" />

            {/* label */}
            <figcaption
                className={`absolute inset-0 flex flex-col items-center justify-center text-center px-6 ${
                    dark ? "text-ivory" : "text-charcoal"
                }`}
            >
                <p className="eyebrow text-gold/90">Placeholder</p>
                <p className="font-serif italic text-xl md:text-2xl mt-3 max-w-[80%]">{label}</p>
                <p className={`mt-3 text-xs ${dark ? "text-ivory/50" : "text-stone"}`}>
                    Awaiting Chrissa's approved photograph
                </p>
            </figcaption>
        </figure>
    );
}

/**
 * EditorialImage — uses an abstract, non-people texture URL with overlay tint.
 */
export function EditorialImage({ src, alt, aspect = "aspect-[4/5]", overlay = "dark", position = "center", className = "" }) {
    return (
        <figure className={`relative overflow-hidden ${aspect} ${className} bg-charcoal`}>
            <img
                src={src}
                alt={alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
                style={{ objectPosition: position }}
            />
            <div
                className={`absolute inset-0 ${
                    overlay === "dark"
                        ? "bg-gradient-to-t from-charcoal/80 via-charcoal/30 to-transparent"
                        : overlay === "oxblood"
                          ? "bg-oxblood/40 mix-blend-multiply"
                          : "bg-ivory/10"
                }`}
            />
        </figure>
    );
}
